// extracted by mini-css-extract-plugin
module.exports = {"button":"LogoutButton_button__1hiJi","iconWrapper":"LogoutButton_iconWrapper__3dZyv","icon":"LogoutButton_icon__2NrkZ","text":"LogoutButton_text__1H_B5"};